import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

// Safe default so consumers rendered outside the provider (e.g. the client
// skeletons reused on admin routes like /admin/help) read topNavHeight = 0
// — i.e. full-height layout — instead of crashing on a destructure of undefined.
export const TopNavHeightContext = createContext({
  topNavHeight: 0,
  setTopNavHeight: () => {},
});

export const TopNavHeightProvider = ({ children }) => {
  const [topNavHeight, setTopNavHeight] = useState(0);

  const value = useMemo(
    () => ({ topNavHeight, setTopNavHeight }),
    [topNavHeight, setTopNavHeight]
  );

  return (
    <TopNavHeightContext.Provider value={value}>
      {children}
    </TopNavHeightContext.Provider>
  );
};

TopNavHeightProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
